import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { KeyedRow } from '../../components/KeyedRow';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { ExportButton } from '../export/ExportButton';
import BankingRow from './components/BankingRow';
import type { BankingDto } from './types/BankingDto';

export function Banking() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const bankingQuery = queryWithFilterAndPages<BankingDto[]>(
		`${organisation}/banking/all`,
		filter.value,
		pagination.value,
	);

	const bankingCountQuery = queryWithFilter<number>(
		`${organisation}/banking/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader
				title={'Banking'}
				filter={filter}
				rightContent={
					<ExportButton apiPath={`${organisation}/banking/export`} />
				}
			/>
			<DataTable
				pagination={pagination}
				totalItems={bankingCountQuery.data?.value ?? 100}
				isRowsLoading={bankingQuery.isLoading}
				isPaginationLoading={bankingCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Till'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Gross Sales'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Variance'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Processed'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Entered By'} />
						</Table.Th>
						<Table.Th>
							<Title label={'View'} />
						</Table.Th>
						<Table.Th />
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{bankingQuery.data?.value.map((bankingData) => (
						<BankingRow key={bankingData.id} initialBank={bankingData} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
